module.exports = __webpack_public_path__ + "images/category_lp/macbook/store_images/4@2x_ea01b5c28d989d9f00d3a84e3d46b7f3.png";